// moment.js language configuration
// language : polish (pl)
// author : Rafal Hirsz : https://github.com/evoL
function plural(n) {
  return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) !== 1;
}

function translate(number, withoutSuffix, key) {
  var result = number + " ";

  switch (key) {
    case 'm':
      return withoutSuffix ? 'minuta' : 'minutę';

    case 'mm':
      return result + (plural(number) ? 'minuty' : 'minut');

    case 'h':
      return withoutSuffix ? 'godzina' : 'godzinę';

    case 'hh':
      return result + (plural(number) ? 'godziny' : 'godzin');

    case 'MM':
      return result + (plural(number) ? 'miesiące' : 'miesięcy');

    case 'yy':
      return result + (plural(number) ? 'lata' : 'lat');
  }
}

require("../moment").lang('pl', {
  months: "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
  monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
  weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
  weekdaysShort: "nie_pon_wt_śr_czw_pt_sb".split("_"),
  weekdaysMin: "N_Pn_Wt_Śr_Cz_Pt_So".split("_"),
  longDateFormat: {
    LT: "HH:mm",
    L: "DD-MM-YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY LT",
    LLLL: "dddd, D MMMM YYYY LT"
  },
  calendar: {
    sameDay: '[Dziś o] LT',
    nextDay: '[Jutro o] LT',
    nextWeek: '[W] dddd [o] LT',
    lastDay: '[Wczoraj o] LT',
    lastWeek: function lastWeek() {
      switch (this.day()) {
        case 0:
          return '[W zeszłą niedzielę o] LT';

        case 3:
          return '[W zeszłą środę o] LT';

        case 6:
          return '[W zeszłą sobotę o] LT';

        default:
          return '[W zeszły] dddd [o] LT';
      }
    },
    sameElse: 'L'
  },
  relativeTime: {
    future: "za %s",
    past: "%s temu",
    s: "kilka sekund",
    m: translate,
    mm: translate,
    h: translate,
    hh: translate,
    d: "1 dzień",
    dd: '%d dni',
    M: "miesiąc",
    MM: translate,
    y: "rok",
    yy: translate
  },
  ordinal: '%d.',
  week: {
    dow: 1,
    // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.

  }
});